module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user.component.html
// module id = 1296
// module chunks = 0